import { WebsiteLevel } from "./WebsiteConfig";

enum ContextItemType
{
    None,
    Listing,
    Profile,
    Office,
    EnquiryTargetProfile,
    Franchise
}

interface ContextItem {
    Type: ContextItemType;
    Id: string;
}

interface Context {
    ClientWebsiteId: string;
    WebsiteId?: string;
    WebsiteLevel?: WebsiteLevel;
    Items: ContextItem[];
}

export { ContextItemType, ContextItem, Context }
